import { render, staticRenderFns } from "./Comprador.vue?vue&type=template&id=3a1aa29d&"
import script from "./Comprador.vue?vue&type=script&lang=js&"
export * from "./Comprador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports